module.exports = __webpack_public_path__ + "static/media/pic12.4025151f.jpg";